export const EMPTY_OPTION = { label: '', value: '' };
